module.exports = __webpack_public_path__ + "static/media/proj_6.80ccf845.png";